import { render, staticRenderFns } from "./ReportSummaryAlt.vue?vue&type=template&id=12c2d101&scoped=true&"
import script from "./ReportSummaryAlt.vue?vue&type=script&lang=ts&"
export * from "./ReportSummaryAlt.vue?vue&type=script&lang=ts&"
import style0 from "./ReportSummaryAlt.vue?vue&type=style&index=0&id=12c2d101&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2d101",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VForm,VIcon,VRow,VTextField})
